import type { ResultType } from "@rocicorp/zero"

interface QueryResult {
	type: ResultType
}

/**
 * Zero hands back rows before a query is authoritative, so an emptiness check
 * on its own flashes the empty state before the real data arrives.
 */
export const isQuerySettled = (result: QueryResult): boolean =>
	result.type === "complete" || result.type === "error"

export const areQueriesSettled = (...results: QueryResult[]): boolean =>
	results.every(isQuerySettled)
